import styled, { css } from 'styled-components'

export const InputWrapper = styled.div`
  min-width: 18rem;
`

export const InputLabel = styled.label`
  ${({ theme, smallLabel }) => css`
    ${theme.fonts.regular};
    padding-bottom: 0.3rem;
    display: inline-block;
    font-weight: 500;

    span {
      color: ${theme.colors.error};
    }

    ${smallLabel &&
    css`
      font-size: 10px;
      padding-top: 1rem;
      text-transform: uppercase;
    `};
  `}
`

export const InputContainer = styled.div`
  ${({ forgotDetails }) => css`
    display: block;
    padding-bottom: ${forgotDetails ? 0 : '0.2rem'};
    padding-top: ${forgotDetails ? 0 : '0.2rem'};
  `}
`

export const InputField = styled.input`
  ${({ theme, forgotDetails, isError }) => css`
    background-color: ${theme.colors.white};
    box-shadow: 0 0 6px rgb(0, 0, 0, 0.3);
    border: none;
    min-height: ${theme.ToRem(37)};
    margin-bottom: 0.3rem;
    padding: 0 1rem 0 0.75rem;
    display: inline-block;
    transition:
      border 0.1s linear,
      background-color 0.1s linear;
    line-height: 1.875rem;

    &::placeholder {
      color: ${theme.colors.darkGrey};
      ${theme.fonts.regular};
      font-weight: 500;
    }

    &:focus {
      border: 2px ${theme.colors.primary.hover};
      border-radius: 4px;
    }
    &:visited {
      outline: none;
    }

    &:focus {
      border: solid 1px
        ${theme.alternativeScheme
          ? theme.colors.borderGrey
          : theme.colors.primary.default};
      box-shadow: ${theme.alternativeScheme
          ? theme.colors.borderGrey
          : theme.colors.primary.default}
        0px 0px 3px 0px;
    }

    ${forgotDetails &&
    css`
      box-shadow: none;
      width: 20rem;
      height: 2.5rem;
      font-size: 14px;
      border-radius: 0.25rem;
      border: 1px solid ${theme.colors.borderGrey};
      margin-bottom: 0;

      &::placeholder {
        color: ${theme.colors.darkGrey};
        font-size: 14px;
      }
    `}

    &.error {
      border: 1px solid ${theme.colors.error};
      box-shadow: 0px 0px 6px ${theme.colors.errorShadow};
    }

    ${isError &&
    css`
      border: 2px solid ${theme.colors.error};
    `}
  `}
`

export const DescriptionContainer = styled.div``

export const ErrorMessage = styled.div`
  ${({ theme }) => css`
    margin-top: 0.125rem;
    color: ${theme.colors.error};
    font-size: ${theme.ToRem(10)};
    font-weight: 500;
  `}
`
export const InputLabelInfo = styled.div`
  ${({ theme }) => css`
    ${theme.fonts.regular};
    font-size: 10px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: ${theme.colors.white};
    text-decoration: none;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${theme.colors.grey};
    text-transform: none;
    margin-left: 4px;

    > a {
      color: ${theme.colors.white};
      text-decoration: none;

      &:hover {
        color: ${theme.colors.white};
        text-decoration: none;
      }
    }

    .__react_component_tooltip {
      ${theme.fonts.regular};
      max-width: 20rem;
      min-height: 2rem;
      border-radius: 0.25rem;
      box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.16);
    }
  `}
`
